export const FONT_SCALE_KEY = 'habilita.font-scale';

export function savedFontScale(): number {
  const value = Number(localStorage.getItem(FONT_SCALE_KEY));
  return Number.isFinite(value) && value >= 0.9 && value <= 1.25 ? value : 1;
}

export function applyFontScale(scale: number): void {
  document.documentElement.style.fontSize = `${Math.round(scale * 100)}%`;
  localStorage.setItem(FONT_SCALE_KEY, String(scale));
}
